import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReplenishmentService {

  replenishmentGraphSubject = new Subject();

  constructor() { }
}
